module.exports={
    "type": "Topology",
    "objects": {
        "collection": {
            "type": "GeometryCollection",
            "geometries": [
                {
                    "type": "Polygon",
                    "properties":{"NAME":"07102"},
                    "arcs": [
                        [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5
                        ]
                    ]
                },
                {
                    "type": "Polygon",
                    "properties":{"NAME":"07103"},
                    "arcs": [
                        [
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            -1
                        ]
                    ]
                },
                {
                    "type": "Polygon",
                    "properties":{"NAME":"07104"},
                    "arcs": [
                        [
                            -2,
                            -12,
                            12,
                            13
                        ]
                    ]
                },
                {
                    "type": "Polygon",
                    "properties":{"NAME":"07105"},
                    "arcs": [
                        [
                            -4,
                            14,
                            15
                        ]
                    ]
                },
                {
                    "type": "Polygon",
                    "properties":{"NAME":"07106"},
                    "arcs": [
                        [
                            -9,
                            16
                        ]
                    ]
                },
                {
                    "type": "Polygon",
                    "properties":{"NAME":"07107"},
                    "arcs": [
                        [
                            -13,
                            -11,
                            17
                        ]
                    ]
                },
                {
                    "type": "Polygon",
                    "properties":{"NAME":"07108"},
                    "arcs": [
                        [
                            18,
                            -7,
                            -6,
                            19,
                            20
                        ]
                    ]
                },
                {
                    "type": "Polygon",
                    "properties":{"NAME":"07112"},
                    "arcs": [
                        [
                            -21,
                            21,
                            22
                        ]
                    ]
                },
                {
                    "type": "Polygon",
                    "properties":{"NAME":"07114"},
                    "arcs": [
                        [
                            -16,
                            23,
                            -22,
                            -20,
                            -5
                        ]
                    ]
                }
            ]
        }
    },
    "arcs": [
        [
            [
                4836,
                4696
            ],
            [
                54,
                167
            ],
            [
                32,
                102
            ],
            [
                86,
                -25
            ],
            [
                14,
                46
            ],
            [
                4,
                16
            ],
            [
                4,
                10
            ],
            [
                34,
                112
            ],
            [
                5,
                20
            ],
            [
                -29,
                8
            ],
            [
                -34,
                11
            ],
            [
                35,
                104
            ],
            [
                -45,
                13
            ],
            [
                -84,
                24
            ],
            [
                35,
                93
            ],
            [
                4,
                14
            ],
            [
                151,
                36
            ],
            [
                2,
                0
            ],
            [
                2,
                0
            ],
            [
                63,
                18
            ],
            [
                7,
                17
            ],
            [
                16,
                37
            ],
            [
                -229,
                84
            ],
            [
                20,
                51
            ],
            [
                3,
                8
            ],
            [
                34,
                86
            ],
            [
                31,
                -12
            ],
            [
                15,
                -11
            ],
            [
                69,
                -79
            ],
            [
                38,
                -37
            ],
            [
                25,
                -19
            ],
            [
                14,
                -8
            ],
            [
                5,
                -3
            ],
            [
                40,
                88
            ],
            [
                24,
                52
            ],
            [
                10,
                21
            ],
            [
                0,
                1
            ],
            [
                -91,
                33
            ],
            [
                47,
                99
            ],
            [
                1,
                2
            ],
            [
                12,
                26
            ],
            [
                44,
                95
            ],
            [
                -62,
                23
            ],
            [
                -138,
                56
            ],
            [
                -2,
                4
            ],
            [
                2,
                -1
            ],
            [
                5,
                0
            ],
            [
                30,
                64
            ],
            [
                23,
                48
            ],
            [
                0,
                1
            ],
            [
                74,
                -28
            ],
            [
                63,
                -24
            ],
            [
                62,
                -22
            ],
            [
                12,
                26
            ],
            [
                3,
                -2
            ],
            [
                61,
                98
            ],
            [
                19,
                31
            ],
            [
                -51,
                22
            ],
            [
                34,
                137
            ],
            [
                128,
                -35
            ],
            [
                31,
                -8
            ],
            [
                11,
                65
            ],
            [
                4,
                25
            ]
        ],
        [
            [
                5613,
                6476
            ],
            [
                146,
                -39
            ],
            [
                27,
                -5
            ],
            [
                14,
                -3
            ],
            [
                7,
                15
            ],
            [
                2,
                5
            ],
            [
                5,
                12
            ],
            [
                1,
                3
            ],
            [
                12,
                -5
            ],
            [
                2,
                -14
            ],
            [
                2,
                -8
            ],
            [
                35,
                7
            ],
            [
                50,
                9
            ],
            [
                12,
                -1
            ],
            [
                9,
                2
            ],
            [
                20,
                1
            ],
            [
                66,
                11
            ],
            [
                7,
                5
            ],
            [
                16,
                13
            ],
            [
                2,
                -19
            ],
            [
                2,
                -18
            ],
            [
                1,
                -13
            ],
            [
                1,
                -3
            ],
            [
                62,
                4
            ],
            [
                11,
                0
            ],
            [
                0,
                11
            ],
            [
                2,
                32
            ],
            [
                1,
                7
            ],
            [
                33,
                3
            ]
        ],
        [
            [
                6161,
                6488
            ],
            [
                -1,
                -5
            ],
            [
                0,
                -6
            ],
            [
                -6,
                -41
            ],
            [
                -1,
                -9
            ],
            [
                7,
                -192
            ],
            [
                3,
                -8
            ],
            [
                2,
                -8
            ],
            [
                16,
                -52
            ],
            [
                43,
                -144
            ],
            [
                95,
                -313
            ],
            [
                122,
                -270
            ],
            [
                10,
                -9
            ],
            [
                21,
                -20
            ]
        ],
        [
            [
                6472,
                5411
            ],
            [
                -23,
                -18
            ],
            [
                -18,
                23
            ],
            [
                -47,
                -34
            ],
            [
                -15,
                -12
            ],
            [
                -19,
                -16
            ],
            [
                -18,
                -17
            ],
            [
                -56,
                -51
            ],
            [
                -39,
                -38
            ],
            [
                -39,
                -39
            ],
            [
                -25,
                -26
            ],
            [
                -21,
                -22
            ],
            [
                -24,
                -26
            ],
            [
                -16,
                -18
            ],
            [
                -74,
                -91
            ],
            [
                -55,
                -68
            ],
            [
                -47,
                -57
            ],
            [
                -26,
                -32
            ],
            [
                -41,
                -50
            ],
            [
                -40,
                -49
            ],
            [
                -16,
                -20
            ],
            [
                -57,
                -68
            ],
            [
                -48,
                -57
            ],
            [
                -39,
                -46
            ],
            [
                18,
                -8
            ],
            [
                -38,
                -46
            ],
            [
                -12,
                -17
            ],
            [
                -42,
                -47
            ],
            [
                -35,
                -36
            ],
            [
                -42,
                -51
            ]
        ],
        [
            [
                5518,
                4374
            ],
            [
                -9,
                -14
            ],
            [
                -36,
                -26
            ],
            [
                -8,
                3
            ],
            [
                -17,
                7
            ],
            [
                -6,
                2
            ],
            [
                -2,
                1
            ],
            [
                -46,
                -36
            ],
            [
                -12,
                -13
            ],
            [
                -42,
                18
            ],
            [
                28,
                62
            ],
            [
                -119,
                50
            ],
            [
                -30,
                -60
            ],
            [
                -107,
                45
            ],
            [
                30,
                60
            ],
            [
                13,
                26
            ],
            [
                21,
                42
            ],
            [
                -50,
                25
            ],
            [
                -29,
                -17
            ],
            [
                -2,
                -1
            ],
            [
                -71,
                -41
            ],
            [
                -25,
                -14
            ],
            [
                -24,
                -13
            ],
            [
                -92,
                -53
            ],
            [
                -40,
                -23
            ]
        ],
        [
            [
                4843,
                4404
            ],
            [
                23,
                64
            ],
            [
                2,
                6
            ],
            [
                -94,
                30
            ],
            [
                2,
                6
            ],
            [
                60,
                186
            ]
        ],
        [
            [
                4836,
                4696
            ],
            [
                -123,
                33
            ],
            [
                -19,
                5
            ],
            [
                -49,
                12
            ],
            [
                -62,
                17
            ],
            [
                62,
                176
            ],
            [
                -53,
                15
            ],
            [
                -11,
                3
            ],
            [
                -1,
                -1
            ],
            [
                -18,
                -56
            ],
            [
                -33,
                -97
            ],
            [
                -8,
                -24
            ],
            [
                -64,
                17
            ],
            [
                -70,
                18
            ],
            [
                -70,
                18
            ],
            [
                -62,
                16
            ],
            [
                -42,
                11
            ],
            [
                -147,
                38
            ],
            [
                -46,
                12
            ],
            [
                -64,
                17
            ],
            [
                -65,
                17
            ],
            [
                -75,
                108
            ],
            [
                -51,
                73
            ],
            [
                -1,
                1
            ],
            [
                -42,
                -10
            ],
            [
                -24,
                -6
            ],
            [
                0,
                -2
            ],
            [
                3,
                -4
            ],
            [
                18,
                -76
            ],
            [
                -10,
                -30
            ],
            [
                -2,
                -6
            ],
            [
                -46,
                12
            ],
            [
                -105,
                27
            ],
            [
                -87,
                23
            ],
            [
                -1,
                0
            ],
            [
                -3,
                1
            ],
            [
                -31,
                8
            ],
            [
                -5,
                -16
            ],
            [
                -1,
                -2
            ],
            [
                0,
                -2
            ],
            [
                -15,
                -45
            ],
            [
                -22,
                -70
            ],
            [
                -29,
                -95
            ],
            [
                -77,
                19
            ],
            [
                -17,
                -55
            ],
            [
                -37,
                -114
            ],
            [
                -15,
                -48
            ],
            [
                -65,
                17
            ],
            [
                -65,
                17
            ],
            [
                -66,
                17
            ],
            [
                -64,
                17
            ],
            [
                -67,
                17
            ],
            [
                -14,
                4
            ],
            [
                -49,
                12
            ],
            [
                -66,
                17
            ],
            [
                -63,
                17
            ],
            [
                -58,
                15
            ],
            [
                18,
                85
            ],
            [
                1,
                2
            ],
            [
                -37,
                -10
            ]
        ],
        [
            [
                2621,
                4861
            ],
            [
                5,
                11
            ],
            [
                -7,
                24
            ],
            [
                6,
                -2
            ],
            [
                6,
                5
            ],
            [
                42,
                132
            ],
            [
                23,
                73
            ],
            [
                44,
                142
            ],
            [
                53,
                167
            ],
            [
                33,
                -9
            ],
            [
                53,
                170
            ],
            [
                51,
                159
            ],
            [
                44,
                142
            ],
            [
                56,
                159
            ],
            [
                -15,
                7
            ],
            [
                -31,
                13
            ],
            [
                -31,
                12
            ],
            [
                -31,
                -65
            ],
            [
                -23,
                9
            ],
            [
                -6,
                2
            ],
            [
                -41,
                14
            ],
            [
                -17,
                -39
            ]
        ],
        [
            [
                2835,
                5987
            ],
            [
                -2,
                1
            ],
            [
                -13,
                7
            ],
            [
                60,
                154
            ],
            [
                46,
                -16
            ],
            [
                48,
                86
            ],
            [
                11,
                20
            ],
            [
                19,
                34
            ],
            [
                31,
                57
            ],
            [
                68,
                123
            ],
            [
                77,
                -36
            ],
            [
                61,
                152
            ],
            [
                13,
                31
            ],
            [
                2,
                6
            ]
        ],
        [
            [
                3256,
                6606
            ],
            [
                64,
                -23
            ],
            [
                64,
                -23
            ],
            [
                12,
                13
            ],
            [
                137,
                135
            ],
            [
                5,
                7
            ]
        ],
        [
            [
                3538,
                6715
            ],
            [
                46,
                -15
            ],
            [
                40,
                -13
            ],
            [
                25,
                -9
            ],
            [
                64,
                -22
            ],
            [
                63,
                -22
            ],
            [
                64,
                -23
            ],
            [
                -79,
                -189
            ],
            [
                -75,
                -181
            ],
            [
                64,
                -23
            ],
            [
                64,
                -22
            ],
            [
                62,
                -21
            ],
            [
                65,
                -23
            ],
            [
                62,
                -22
            ],
            [
                67,
                -23
            ],
            [
                3,
                -1
            ],
            [
                72,
                -25
            ],
            [
                64,
                -24
            ],
            [
                65,
                -24
            ],
            [
                65,
                -24
            ],
            [
                43,
                100
            ],
            [
                64,
                145
            ],
            [
                -7,
                16
            ],
            [
                34,
                60
            ],
            [
                40,
                71
            ],
            [
                48,
                81
            ],
            [
                94,
                -39
            ],
            [
                43,
                -18
            ],
            [
                15,
                -6
            ],
            [
                -4,
                10
            ],
            [
                -4,
                17
            ],
            [
                -3,
                15
            ],
            [
                -1,
                11
            ],
            [
                -3,
                20
            ],
            [
                -2,
                19
            ],
            [
                0,
                18
            ],
            [
                2,
                17
            ],
            [
                3,
                19
            ],
            [
                5,
                20
            ],
            [
                5,
                14
            ],
            [
                7,
                17
            ],
            [
                8,
                15
            ],
            [
                11,
                17
            ],
            [
                11,
                15
            ],
            [
                12,
                13
            ],
            [
                13,
                13
            ],
            [
                39,
                37
            ]
        ],
        [
            [
                4812,
                6726
            ],
            [
                52,
                -32
            ],
            [
                7,
                -5
            ],
            [
                20,
                10
            ],
            [
                40,
                12
            ],
            [
                106,
                -42
            ],
            [
                74,
                -27
            ],
            [
                60,
                -22
            ],
            [
                137,
                -51
            ],
            [
                60,
                -14
            ],
            [
                13,
                -3
            ],
            [
                75,
                -25
            ],
            [
                157,
                -51
            ]
        ],
        [
            [
                4812,
                6726
            ],
            [
                5,
                5
            ],
            [
                19,
                20
            ],
            [
                8,
                9
            ],
            [
                14,
                22
            ],
            [
                11,
                23
            ],
            [
                3,
                19
            ],
            [
                -1,
                18
            ],
            [
                -4,
                36
            ],
            [
                -5,
                30
            ],
            [
                -6,
                35
            ],
            [
                -9,
                49
            ],
            [
                -11,
                38
            ],
            [
                -43,
                99
            ],
            [
                -11,
                37
            ],
            [
                -2,
                13
            ],
            [
                -4,
                19
            ],
            [
                -3,
                56
            ],
            [
                3,
                37
            ],
            [
                10,
                52
            ],
            [
                16,
                55
            ],
            [
                3,
                13
            ],
            [
                14,
                47
            ],
            [
                19,
                55
            ],
            [
                26,
                57
            ],
            [
                19,
                35
            ],
            [
                21,
                32
            ],
            [
                27,
                34
            ],
            [
                65,
                69
            ],
            [
                25,
                31
            ],
            [
                27,
                33
            ],
            [
                31,
                47
            ],
            [
                37,
                65
            ],
            [
                30,
                53
            ],
            [
                2,
                4
            ],
            [
                15,
                27
            ],
            [
                6,
                -12
            ],
            [
                46,
                -82
            ],
            [
                12,
                -21
            ],
            [
                71,
                -126
            ],
            [
                4,
                10
            ],
            [
                50,
                115
            ],
            [
                14,
                30
            ],
            [
                139,
                323
            ],
            [
                57,
                133
            ],
            [
                32,
                75
            ],
            [
                22,
                50
            ],
            [
                78,
                180
            ],
            [
                75,
                175
            ],
            [
                -69,
                26
            ],
            [
                -16,
                9
            ],
            [
                -14,
                87
            ],
            [
                42,
                84
            ],
            [
                -27,
                11
            ],
            [
                -112,
                44
            ],
            [
                -16,
                5
            ],
            [
                -62,
                22
            ],
            [
                17,
                33
            ],
            [
                10,
                27
            ],
            [
                1,
                2
            ],
            [
                10,
                29
            ],
            [
                7,
                31
            ],
            [
                4,
                29
            ],
            [
                -2,
                40
            ],
            [
                -7,
                30
            ],
            [
                -9,
                29
            ],
            [
                -7,
                12
            ],
            [
                -12,
                8
            ],
            [
                4,
                17
            ],
            [
                22,
                9
            ],
            [
                55,
                164
            ],
            [
                -22,
                112
            ],
            [
                -21,
                46
            ],
            [
                -18,
                12
            ]
        ],
        [
            [
                5527,
                9768
            ],
            [
                2,
                2
            ],
            [
                3,
                9
            ],
            [
                13,
                30
            ],
            [
                7,
                13
            ],
            [
                8,
                12
            ],
            [
                6,
                8
            ],
            [
                7,
                14
            ],
            [
                6,
                22
            ],
            [
                1,
                4
            ],
            [
                2,
                2
            ],
            [
                4,
                4
            ],
            [
                24,
                10
            ],
            [
                52,
                21
            ],
            [
                21,
                15
            ],
            [
                13,
                13
            ],
            [
                12,
                12
            ],
            [
                33,
                31
            ],
            [
                1,
                0
            ],
            [
                7,
                7
            ],
            [
                5,
                2
            ],
            [
                5,
                0
            ],
            [
                15,
                -10
            ],
            [
                11,
                -8
            ],
            [
                28,
                -37
            ],
            [
                35,
                -37
            ],
            [
                15,
                -10
            ],
            [
                13,
                -4
            ],
            [
                9,
                -5
            ],
            [
                -2,
                3
            ],
            [
                17,
                -5
            ],
            [
                16,
                -3
            ],
            [
                26,
                -3
            ],
            [
                20,
                2
            ],
            [
                2,
                0
            ],
            [
                19,
                -2
            ],
            [
                28,
                -7
            ],
            [
                25,
                -4
            ],
            [
                27,
                -1
            ],
            [
                27,
                -2
            ],
            [
                33,
                2
            ],
            [
                26,
                -1
            ],
            [
                17,
                -5
            ],
            [
                28,
                -17
            ],
            [
                28,
                -26
            ],
            [
                13,
                -12
            ],
            [
                11,
                -9
            ],
            [
                35,
                -32
            ],
            [
                47,
                -27
            ],
            [
                43,
                -19
            ],
            [
                37,
                -19
            ],
            [
                30,
                -19
            ],
            [
                43,
                -28
            ],
            [
                19,
                -10
            ],
            [
                28,
                -16
            ],
            [
                30,
                -21
            ],
            [
                26,
                -23
            ],
            [
                69,
                -34
            ],
            [
                24,
                -12
            ],
            [
                58,
                -29
            ],
            [
                28,
                -13
            ],
            [
                36,
                -10
            ],
            [
                19,
                -8
            ],
            [
                29,
                -16
            ],
            [
                39,
                -19
            ],
            [
                23,
                -14
            ],
            [
                22,
                -9
            ],
            [
                24,
                -13
            ],
            [
                33,
                -16
            ],
            [
                84,
                -42
            ],
            [
                32,
                -16
            ],
            [
                84,
                -17
            ],
            [
                36,
                -9
            ],
            [
                18,
                -3
            ],
            [
                11,
                -2
            ],
            [
                21,
                2
            ],
            [
                38,
                -13
            ],
            [
                42,
                -13
            ],
            [
                31,
                -4
            ],
            [
                48,
                -6
            ],
            [
                6,
                -1
            ],
            [
                -2,
                -15
            ],
            [
                -6,
                -18
            ],
            [
                -2,
                -8
            ],
            [
                -2,
                -20
            ],
            [
                -40,
                -103
            ],
            [
                -22,
                -26
            ],
            [
                -14,
                -8
            ],
            [
                -14,
                -8
            ],
            [
                -8,
                -4
            ],
            [
                -42,
                -51
            ],
            [
                -19,
                -20
            ],
            [
                -116,
                -127
            ],
            [
                -74,
                -89
            ],
            [
                -2,
                -6
            ],
            [
                -8,
                -15
            ],
            [
                -7,
                -16
            ],
            [
                -21,
                -33
            ],
            [
                -17,
                -27
            ],
            [
                -6,
                -9
            ],
            [
                -3,
                -4
            ],
            [
                -9,
                -14
            ],
            [
                -28,
                -44
            ],
            [
                -35,
                -47
            ],
            [
                -9,
                -17
            ],
            [
                -38,
                -63
            ],
            [
                -41,
                -168
            ],
            [
                -19,
                -80
            ],
            [
                -32,
                -68
            ],
            [
                -22,
                -49
            ],
            [
                -22,
                -47
            ],
            [
                -4,
                -7
            ],
            [
                -6,
                -8
            ],
            [
                -41,
                -59
            ],
            [
                -20,
                -28
            ],
            [
                -33,
                -40
            ],
            [
                -33,
                -40
            ],
            [
                -27,
                -32
            ],
            [
                -26,
                -32
            ],
            [
                -21,
                -25
            ],
            [
                -105,
                -134
            ],
            [
                -6,
                -9
            ],
            [
                -27,
                -47
            ],
            [
                -30,
                -66
            ],
            [
                -9,
                -19
            ],
            [
                -4,
                -10
            ],
            [
                -5,
                -10
            ],
            [
                -14,
                -20
            ],
            [
                -14,
                -66
            ],
            [
                -28,
                -81
            ],
            [
                -28,
                -82
            ],
            [
                -11,
                -35
            ],
            [
                -2,
                -8
            ],
            [
                -4,
                -28
            ],
            [
                -15,
                -110
            ],
            [
                -3,
                -18
            ],
            [
                -7,
                -82
            ],
            [
                -38,
                -225
            ],
            [
                -14,
                -79
            ],
            [
                -6,
                -43
            ],
            [
                -17,
                -132
            ]
        ],
        [
            [
                6472,
                5411
            ],
            [
                2,
                -1
            ],
            [
                120,
                -112
            ],
            [
                39,
                -11
            ],
            [
                89,
                -25
            ],
            [
                58,
                -16
            ],
            [
                56,
                -16
            ],
            [
                21,
                -5
            ],
            [
                46,
                -13
            ],
            [
                30,
                3
            ],
            [
                37,
                4
            ],
            [
                38,
                4
            ],
            [
                17,
                2
            ],
            [
                2,
                0
            ],
            [
                20,
                2
            ],
            [
                29,
                3
            ],
            [
                74,
                8
            ],
            [
                8,
                1
            ],
            [
                34,
                4
            ],
            [
                36,
                4
            ],
            [
                217,
                33
            ],
            [
                8,
                1
            ],
            [
                59,
                9
            ],
            [
                5,
                0
            ],
            [
                5,
                5
            ],
            [
                128,
                106
            ],
            [
                4,
                3
            ],
            [
                2,
                3
            ],
            [
                185,
                312
            ],
            [
                24,
                12
            ],
            [
                58,
                28
            ],
            [
                118,
                57
            ],
            [
                116,
                58
            ],
            [
                44,
                21
            ],
            [
                15,
                7
            ],
            [
                20,
                2
            ],
            [
                912,
                52
            ],
            [
                52,
                3
            ],
            [
                29,
                2
            ],
            [
                13,
                1
            ],
            [
                10,
                0
            ],
            [
                16,
                1
            ],
            [
                10,
                1
            ],
            [
                5,
                -2
            ],
            [
                12,
                -3
            ],
            [
                12,
                -4
            ],
            [
                4,
                -1
            ],
            [
                29,
                -9
            ],
            [
                53,
                -16
            ],
            [
                5,
                -4
            ],
            [
                2,
                -1
            ],
            [
                3,
                -2
            ],
            [
                9,
                -7
            ],
            [
                7,
                -5
            ],
            [
                21,
                -14
            ],
            [
                41,
                -30
            ],
            [
                36,
                -25
            ],
            [
                36,
                -26
            ],
            [
                24,
                -17
            ],
            [
                25,
                -18
            ],
            [
                8,
                -5
            ],
            [
                14,
                -9
            ],
            [
                27,
                -18
            ],
            [
                7,
                -34
            ],
            [
                5,
                -25
            ],
            [
                16,
                -79
            ],
            [
                3,
                -14
            ],
            [
                8,
                -39
            ],
            [
                6,
                -28
            ],
            [
                -8,
                -36
            ],
            [
                -7,
                -38
            ],
            [
                -21,
                -104
            ],
            [
                -1,
                -4
            ],
            [
                -42,
                -223
            ],
            [
                -2,
                -5
            ],
            [
                -62,
                -250
            ],
            [
                -101,
                -405
            ],
            [
                -45,
                -179
            ],
            [
                -29,
                -166
            ],
            [
                31,
                -186
            ],
            [
                49,
                -260
            ],
            [
                7,
                -15
            ],
            [
                38,
                -78
            ],
            [
                38,
                -79
            ],
            [
                24,
                -51
            ],
            [
                25,
                -51
            ],
            [
                92,
                -190
            ],
            [
                9,
                -19
            ],
            [
                39,
                -81
            ],
            [
                39,
                -81
            ],
            [
                92,
                -189
            ],
            [
                91,
                -189
            ],
            [
                47,
                -97
            ],
            [
                -40,
                -54
            ],
            [
                -68,
                -94
            ],
            [
                -20,
                -29
            ],
            [
                -195,
                -286
            ]
        ],
        [
            [
                9676,
                2090
            ],
            [
                -26,
                16
            ],
            [
                -137,
                78
            ],
            [
                -41,
                23
            ],
            [
                -140,
                87
            ],
            [
                -36,
                24
            ],
            [
                -68,
                46
            ],
            [
                -156,
                96
            ],
            [
                -116,
                77
            ],
            [
                -97,
                69
            ],
            [
                -64,
                51
            ],
            [
                -67,
                46
            ],
            [
                -3,
                2
            ],
            [
                -113,
                76
            ],
            [
                -52,
                34
            ],
            [
                -56,
                37
            ],
            [
                -35,
                21
            ],
            [
                -34,
                23
            ],
            [
                -32,
                19
            ],
            [
                -63,
                33
            ],
            [
                -367,
                162
            ],
            [
                -120,
                54
            ],
            [
                -127,
                68
            ],
            [
                -19,
                12
            ],
            [
                -80,
                31
            ],
            [
                -29,
                9
            ],
            [
                -51,
                -32
            ],
            [
                -50,
                -34
            ],
            [
                -39,
                -32
            ],
            [
                -45,
                -39
            ],
            [
                -3,
                5
            ],
            [
                -19,
                26
            ],
            [
                -10,
                10
            ],
            [
                -10,
                9
            ],
            [
                -79,
                57
            ],
            [
                -2,
                3
            ],
            [
                -5,
                1
            ],
            [
                -8,
                4
            ],
            [
                -54,
                21
            ],
            [
                -33,
                14
            ],
            [
                -4,
                2
            ],
            [
                -159,
                66
            ],
            [
                -125,
                52
            ],
            [
                68,
                77
            ],
            [
                29,
                25
            ],
            [
                19,
                22
            ],
            [
                -61,
                28
            ],
            [
                -24,
                14
            ],
            [
                -8,
                4
            ],
            [
                -18,
                11
            ],
            [
                -50,
                33
            ],
            [
                52,
                107
            ],
            [
                -8,
                3
            ],
            [
                -107,
                42
            ],
            [
                -58,
                20
            ],
            [
                -18,
                8
            ],
            [
                -58,
                -10
            ],
            [
                -186,
                -31
            ],
            [
                -94,
                -15
            ],
            [
                -193,
                -30
            ],
            [
                3,
                11
            ],
            [
                91,
                182
            ],
            [
                1,
                4
            ],
            [
                25,
                61
            ],
            [
                -199,
                84
            ],
            [
                -143,
                61
            ],
            [
                -4,
                2
            ],
            [
                9,
                27
            ],
            [
                -25,
                14
            ],
            [
                7,
                22
            ],
            [
                -99,
                50
            ],
            [
                -4,
                -8
            ],
            [
                -19,
                7
            ],
            [
                -91,
                39
            ],
            [
                -192,
                81
            ],
            [
                -29,
                12
            ]
        ],
        [
            [
                2835,
                5987
            ],
            [
                -1,
                -6
            ],
            [
                -6,
                -9
            ],
            [
                -8,
                -11
            ],
            [
                -47,
                26
            ],
            [
                -9,
                5
            ],
            [
                -18,
                -28
            ],
            [
                -8,
                -12
            ],
            [
                -10,
                -14
            ],
            [
                -8,
                4
            ],
            [
                -9,
                5
            ],
            [
                -23,
                -35
            ],
            [
                -19,
                -28
            ],
            [
                -1,
                -3
            ],
            [
                -5,
                1
            ],
            [
                -25,
                13
            ],
            [
                -29,
                16
            ],
            [
                -5,
                3
            ],
            [
                -7,
                4
            ],
            [
                -20,
                -30
            ],
            [
                -23,
                -34
            ],
            [
                -3,
                -5
            ],
            [
                -7,
                -11
            ],
            [
                -30,
                17
            ],
            [
                -11,
                7
            ],
            [
                -15,
                8
            ],
            [
                -22,
                13
            ],
            [
                -2,
                1
            ],
            [
                -62,
                -94
            ],
            [
                -10,
                -15
            ],
            [
                -4,
                -6
            ],
            [
                -48,
                13
            ],
            [
                -32,
                9
            ],
            [
                -6,
                -19
            ],
            [
                -14,
                -41
            ],
            [
                -31,
                9
            ],
            [
                0,
                1
            ],
            [
                -31,
                8
            ],
            [
                -10,
                -29
            ],
            [
                -12,
                4
            ],
            [
                -20,
                5
            ],
            [
                -7,
                -22
            ],
            [
                -31,
                9
            ],
            [
                -2,
                -7
            ],
            [
                -3,
                -9
            ],
            [
                -7,
                -22
            ],
            [
                -3,
                -8
            ],
            [
                -5,
                1
            ],
            [
                -25,
                8
            ],
            [
                -32,
                10
            ],
            [
                -17,
                -52
            ],
            [
                -30,
                9
            ],
            [
                -31,
                9
            ],
            [
                -3,
                -4
            ],
            [
                -7,
                -23
            ],
            [
                -2,
                -10
            ],
            [
                -1,
                -7
            ],
            [
                -13,
                -22
            ],
            [
                -23,
                11
            ],
            [
                -9,
                -1
            ],
            [
                -7,
                -1
            ],
            [
                -23,
                12
            ],
            [
                -28,
                -49
            ],
            [
                -22,
                9
            ],
            [
                -40,
                16
            ],
            [
                -5,
                2
            ],
            [
                -23,
                12
            ],
            [
                -18,
                -27
            ],
            [
                -41,
                -62
            ],
            [
                -33,
                -23
            ],
            [
                -31,
                -16
            ],
            [
                -14,
                5
            ],
            [
                -8,
                3
            ],
            [
                -20,
                -10
            ],
            [
                -4,
                -1
            ],
            [
                -46,
                -34
            ],
            [
                -48,
                -33
            ],
            [
                -51,
                -35
            ],
            [
                -4,
                -3
            ],
            [
                -34,
                -24
            ],
            [
                -10,
                -2
            ],
            [
                -9,
                -2
            ],
            [
                -8,
                2
            ],
            [
                -10,
                3
            ],
            [
                0,
                1
            ],
            [
                -101,
                34
            ],
            [
                -57,
                19
            ],
            [
                -9,
                5
            ],
            [
                -9,
                2
            ],
            [
                -29,
                -66
            ],
            [
                -3,
                -7
            ],
            [
                -32,
                12
            ],
            [
                -31,
                12
            ],
            [
                -7,
                -17
            ],
            [
                -25,
                -56
            ],
            [
                -20,
                -47
            ],
            [
                -14,
                6
            ],
            [
                -10,
                3
            ],
            [
                -7,
                5
            ],
            [
                -7,
                4
            ],
            [
                -24,
                9
            ],
            [
                -1,
                -3
            ],
            [
                -17,
                -39
            ],
            [
                -2,
                -5
            ],
            [
                -32,
                11
            ],
            [
                -12,
                -29
            ],
            [
                -18,
                -40
            ],
            [
                -45,
                17
            ],
            [
                -6,
                -15
            ],
            [
                -9,
                -15
            ],
            [
                -33,
                -74
            ],
            [
                -14,
                5
            ],
            [
                -24,
                9
            ],
            [
                -9,
                -1
            ],
            [
                -10,
                -2
            ],
            [
                -15,
                6
            ],
            [
                -9,
                3
            ],
            [
                -2,
                1
            ],
            [
                -34,
                -77
            ],
            [
                -1,
                -4
            ],
            [
                -24,
                9
            ],
            [
                -2,
                1
            ],
            [
                -9,
                1
            ],
            [
                -7,
                0
            ],
            [
                -26,
                9
            ],
            [
                -2,
                -6
            ],
            [
                -29,
                -65
            ],
            [
                -25,
                9
            ],
            [
                -7,
                1
            ],
            [
                -9,
                1
            ],
            [
                -27,
                10
            ],
            [
                1,
                2
            ],
            [
                -3,
                0
            ],
            [
                6,
                12
            ],
            [
                -15,
                6
            ],
            [
                3,
                4
            ],
            [
                3,
                1
            ],
            [
                -1,
                5
            ],
            [
                18,
                -6
            ],
            [
                26,
                58
            ],
            [
                5,
                21
            ],
            [
                -30,
                9
            ],
            [
                -30,
                8
            ],
            [
                18,
                52
            ],
            [
                -23,
                6
            ],
            [
                -25,
                8
            ],
            [
                0,
                7
            ],
            [
                0,
                3
            ],
            [
                0,
                4
            ],
            [
                -1,
                4
            ],
            [
                -1,
                4
            ],
            [
                0,
                4
            ],
            [
                1,
                5
            ],
            [
                -5,
                2
            ],
            [
                -4,
                -1
            ],
            [
                -1,
                2
            ],
            [
                -3,
                1
            ],
            [
                -3,
                2
            ],
            [
                -4,
                1
            ],
            [
                -4,
                2
            ],
            [
                -14,
                4
            ],
            [
                -31,
                10
            ],
            [
                -68,
                21
            ],
            [
                -99,
                31
            ],
            [
                -35,
                10
            ],
            [
                -36,
                11
            ],
            [
                -3,
                0
            ],
            [
                -15,
                7
            ],
            [
                -21,
                8
            ],
            [
                -13,
                7
            ],
            [
                -13,
                7
            ],
            [
                -11,
                9
            ],
            [
                -8,
                7
            ],
            [
                -10,
                11
            ],
            [
                -13,
                14
            ],
            [
                -7,
                9
            ],
            [
                -26,
                28
            ],
            [
                -15,
                22
            ],
            [
                -5,
                7
            ],
            [
                -6,
                12
            ],
            [
                -5,
                10
            ],
            [
                -5,
                21
            ],
            [
                -3,
                11
            ],
            [
                -8,
                37
            ],
            [
                -6,
                33
            ],
            [
                -3,
                13
            ],
            [
                216,
                186
            ],
            [
                23,
                20
            ],
            [
                27,
                -16
            ],
            [
                85,
                71
            ],
            [
                33,
                26
            ],
            [
                6,
                6
            ],
            [
                65,
                -30
            ],
            [
                3,
                4
            ],
            [
                61,
                77
            ],
            [
                18,
                24
            ],
            [
                20,
                -8
            ],
            [
                219,
                -95
            ],
            [
                13,
                25
            ],
            [
                4,
                8
            ],
            [
                101,
                130
            ],
            [
                4,
                6
            ],
            [
                9,
                31
            ],
            [
                -22,
                9
            ],
            [
                1,
                5
            ],
            [
                0,
                1
            ],
            [
                5,
                16
            ],
            [
                8,
                25
            ],
            [
                34,
                109
            ],
            [
                38,
                22
            ],
            [
                73,
                42
            ],
            [
                2,
                7
            ],
            [
                -12,
                0
            ],
            [
                81,
                293
            ],
            [
                12,
                -3
            ],
            [
                16,
                60
            ],
            [
                16,
                53
            ],
            [
                4,
                7
            ],
            [
                -14,
                7
            ],
            [
                43,
                34
            ],
            [
                84,
                61
            ],
            [
                76,
                -7
            ],
            [
                33,
                -2
            ],
            [
                58,
                -3
            ],
            [
                76,
                1
            ],
            [
                73,
                -4
            ],
            [
                70,
                -3
            ],
            [
                71,
                0
            ],
            [
                63,
                -3
            ],
            [
                -5,
                -18
            ],
            [
                -11,
                -33
            ],
            [
                -44,
                -107
            ],
            [
                -14,
                -30
            ],
            [
                -3,
                -7
            ],
            [
                -62,
                -147
            ],
            [
                -10,
                -22
            ],
            [
                -19,
                -48
            ],
            [
                7,
                0
            ],
            [
                21,
                -2
            ],
            [
                18,
                -1
            ],
            [
                12,
                -2
            ],
            [
                15,
                -2
            ],
            [
                16,
                -2
            ],
            [
                27,
                -5
            ],
            [
                13,
                -2
            ],
            [
                8,
                -2
            ],
            [
                20,
                -5
            ],
            [
                22,
                -6
            ],
            [
                16,
                -5
            ],
            [
                16,
                -4
            ],
            [
                46,
                -17
            ],
            [
                3,
                -1
            ],
            [
                3,
                -1
            ],
            [
                5,
                -2
            ],
            [
                41,
                -15
            ],
            [
                15,
                -5
            ],
            [
                7,
                -2
            ],
            [
                28,
                -9
            ],
            [
                29,
                -8
            ],
            [
                15,
                -4
            ],
            [
                29,
                -6
            ],
            [
                36,
                -6
            ],
            [
                31,
                -4
            ],
            [
                56,
                170
            ],
            [
                16,
                49
            ],
            [
                25,
                71
            ],
            [
                8,
                34
            ],
            [
                44,
                1
            ],
            [
                75,
                3
            ],
            [
                6,
                0
            ],
            [
                -4,
                2
            ],
            [
                75,
                5
            ],
            [
                60,
                5
            ],
            [
                16,
                1
            ],
            [
                49,
                0
            ],
            [
                28,
                4
            ],
            [
                86,
                8
            ],
            [
                51,
                5
            ],
            [
                20,
                0
            ],
            [
                64,
                0
            ],
            [
                377,
                9
            ],
            [
                34,
                -13
            ],
            [
                17,
                34
            ],
            [
                26,
                -8
            ]
        ],
        [
            [
                3538,
                6715
            ],
            [
                6,
                13
            ],
            [
                33,
                -10
            ],
            [
                14,
                -1
            ],
            [
                8,
                0
            ],
            [
                9,
                20
            ],
            [
                37,
                94
            ],
            [
                20,
                45
            ],
            [
                7,
                -3
            ],
            [
                11,
                29
            ],
            [
                37,
                105
            ],
            [
                5,
                20
            ],
            [
                60,
                -14
            ],
            [
                30,
                -8
            ],
            [
                8,
                26
            ],
            [
                15,
                45
            ],
            [
                27,
                93
            ],
            [
                17,
                32
            ],
            [
                46,
                -21
            ],
            [
                23,
                46
            ],
            [
                10,
                17
            ],
            [
                13,
                29
            ],
            [
                74,
                173
            ],
            [
                9,
                22
            ],
            [
                18,
                -7
            ],
            [
                73,
                157
            ],
            [
                6,
                19
            ],
            [
                -9,
                4
            ],
            [
                -13,
                7
            ],
            [
                -31,
                20
            ],
            [
                -27,
                15
            ],
            [
                70,
                111
            ],
            [
                1,
                18
            ],
            [
                -16,
                63
            ],
            [
                9,
                -6
            ],
            [
                10,
                -4
            ],
            [
                20,
                -9
            ],
            [
                65,
                -23
            ],
            [
                65,
                143
            ],
            [
                7,
                18
            ],
            [
                8,
                26
            ],
            [
                71,
                153
            ],
            [
                23,
                58
            ],
            [
                21,
                51
            ],
            [
                7,
                16
            ],
            [
                12,
                -17
            ],
            [
                20,
                -27
            ],
            [
                11,
                24
            ],
            [
                4,
                17
            ],
            [
                36,
                99
            ],
            [
                30,
                91
            ],
            [
                31,
                93
            ],
            [
                13,
                40
            ],
            [
                32,
                93
            ],
            [
                14,
                44
            ],
            [
                15,
                45
            ],
            [
                5,
                0
            ],
            [
                7,
                -3
            ],
            [
                25,
                11
            ],
            [
                8,
                4
            ],
            [
                1,
                -3
            ],
            [
                1,
                -1
            ],
            [
                2,
                -2
            ],
            [
                40,
                11
            ],
            [
                12,
                5
            ],
            [
                6,
                7
            ],
            [
                13,
                14
            ],
            [
                38,
                -14
            ],
            [
                3,
                -1
            ],
            [
                9,
                -3
            ],
            [
                12,
                31
            ],
            [
                19,
                42
            ],
            [
                31,
                -7
            ],
            [
                14,
                33
            ],
            [
                10,
                23
            ],
            [
                2,
                4
            ],
            [
                3,
                3
            ],
            [
                3,
                1
            ],
            [
                4,
                0
            ],
            [
                5,
                -1
            ],
            [
                15,
                -5
            ],
            [
                7,
                -3
            ],
            [
                1,
                4
            ],
            [
                23,
                52
            ],
            [
                22,
                -8
            ],
            [
                8,
                -3
            ],
            [
                6,
                -2
            ],
            [
                26,
                -10
            ],
            [
                2,
                3
            ],
            [
                10,
                24
            ],
            [
                14,
                32
            ],
            [
                19,
                23
            ],
            [
                26,
                33
            ],
            [
                24,
                -18
            ],
            [
                22,
                -16
            ],
            [
                -2,
                -1
            ],
            [
                -8,
                -15
            ],
            [
                4,
                -3
            ],
            [
                25,
                -7
            ],
            [
                39,
                -14
            ],
            [
                14,
                31
            ],
            [
                14,
                32
            ],
            [
                14,
                -5
            ],
            [
                27,
                -12
            ],
            [
                33,
                -13
            ],
            [
                7,
                18
            ],
            [
                8,
                18
            ],
            [
                40,
                94
            ],
            [
                32,
                73
            ],
            [
                -31,
                11
            ],
            [
                -30,
                12
            ],
            [
                38,
                85
            ],
            [
                -28,
                18
            ],
            [
                -8,
                9
            ],
            [
                -10,
                6
            ],
            [
                -5,
                4
            ],
            [
                -11,
                6
            ],
            [
                4,
                5
            ],
            [
                -5,
                6
            ],
            [
                10,
                49
            ],
            [
                37,
                46
            ],
            [
                12,
                16
            ],
            [
                33,
                35
            ],
            [
                -35,
                16
            ],
            [
                108,
                128
            ],
            [
                6,
                8
            ],
            [
                12,
                14
            ],
            [
                11,
                16
            ],
            [
                4,
                4
            ],
            [
                9,
                10
            ],
            [
                8,
                9
            ]
        ],
        [
            [
                2395,
                4141
            ],
            [
                42,
                51
            ],
            [
                3,
                6
            ],
            [
                12,
                18
            ],
            [
                -17,
                11
            ],
            [
                -16,
                8
            ],
            [
                19,
                28
            ],
            [
                13,
                18
            ],
            [
                10,
                17
            ],
            [
                -29,
                14
            ],
            [
                2,
                4
            ],
            [
                20,
                35
            ],
            [
                27,
                69
            ],
            [
                5,
                28
            ],
            [
                8,
                26
            ],
            [
                3,
                7
            ],
            [
                4,
                7
            ],
            [
                7,
                26
            ],
            [
                -9,
                2
            ],
            [
                16,
                26
            ],
            [
                6,
                12
            ],
            [
                14,
                41
            ],
            [
                0,
                5
            ],
            [
                16,
                26
            ],
            [
                -14,
                7
            ],
            [
                49,
                68
            ],
            [
                3,
                5
            ],
            [
                -27,
                17
            ],
            [
                8,
                16
            ],
            [
                -4,
                3
            ],
            [
                14,
                20
            ],
            [
                5,
                0
            ],
            [
                6,
                22
            ],
            [
                5,
                10
            ],
            [
                6,
                10
            ],
            [
                4,
                15
            ],
            [
                12,
                4
            ],
            [
                -7,
                22
            ],
            [
                10,
                16
            ]
        ],
        [
            [
                4843,
                4404
            ],
            [
                -10,
                -6
            ],
            [
                38,
                -64
            ],
            [
                -190,
                -93
            ],
            [
                -38,
                -18
            ],
            [
                -15,
                -33
            ],
            [
                -21,
                -48
            ],
            [
                -57,
                24
            ],
            [
                -27,
                -60
            ],
            [
                -24,
                -55
            ],
            [
                -26,
                -58
            ],
            [
                -27,
                -58
            ],
            [
                -25,
                -56
            ],
            [
                -26,
                -59
            ],
            [
                123,
                -53
            ],
            [
                -27,
                -55
            ],
            [
                -119,
                52
            ],
            [
                -2,
                0
            ],
            [
                -33,
                -58
            ],
            [
                -30,
                -51
            ],
            [
                -34,
                -60
            ],
            [
                -31,
                -54
            ],
            [
                136,
                -59
            ],
            [
                -56,
                -114
            ]
        ],
        [
            [
                4322,
                3368
            ],
            [
                -145,
                61
            ],
            [
                -62,
                24
            ],
            [
                -9,
                3
            ],
            [
                -12,
                5
            ],
            [
                -63,
                22
            ],
            [
                -11,
                4
            ],
            [
                -10,
                3
            ],
            [
                -2,
                1
            ],
            [
                33,
                113
            ],
            [
                11,
                21
            ],
            [
                14,
                10
            ],
            [
                21,
                12
            ],
            [
                -3,
                1
            ],
            [
                -36,
                11
            ],
            [
                -48,
                14
            ],
            [
                -2,
                -39
            ],
            [
                -22,
                -31
            ],
            [
                -30,
                -90
            ],
            [
                -82,
                30
            ],
            [
                -67,
                24
            ],
            [
                -67,
                23
            ],
            [
                -4,
                -8
            ],
            [
                -52,
                27
            ],
            [
                -5,
                2
            ],
            [
                -10,
                3
            ],
            [
                -57,
                23
            ],
            [
                -10,
                4
            ],
            [
                -6,
                3
            ],
            [
                -60,
                29
            ],
            [
                -66,
                26
            ],
            [
                -69,
                27
            ],
            [
                -70,
                28
            ],
            [
                36,
                108
            ],
            [
                -78,
                22
            ],
            [
                -16,
                5
            ],
            [
                -9,
                -34
            ],
            [
                -184,
                54
            ],
            [
                -9,
                -27
            ],
            [
                -3,
                -8
            ],
            [
                -9,
                -25
            ],
            [
                -5,
                1
            ],
            [
                -111,
                31
            ],
            [
                -6,
                2
            ],
            [
                -27,
                9
            ],
            [
                -23,
                7
            ],
            [
                10,
                23
            ],
            [
                16,
                36
            ],
            [
                3,
                8
            ],
            [
                -34,
                13
            ],
            [
                0,
                3
            ],
            [
                0,
                6
            ],
            [
                -1,
                6
            ],
            [
                -4,
                5
            ],
            [
                -7,
                7
            ],
            [
                -10,
                4
            ],
            [
                -12,
                3
            ],
            [
                -23,
                0
            ],
            [
                -1,
                1
            ],
            [
                -2,
                1
            ],
            [
                -12,
                14
            ],
            [
                -7,
                5
            ],
            [
                -6,
                2
            ],
            [
                -6,
                1
            ],
            [
                -6,
                -1
            ],
            [
                -5,
                -5
            ],
            [
                -36,
                -64
            ],
            [
                -15,
                8
            ],
            [
                -7,
                3
            ],
            [
                -19,
                5
            ],
            [
                -20,
                6
            ],
            [
                -7,
                2
            ],
            [
                -30,
                8
            ],
            [
                -7,
                4
            ],
            [
                -4,
                2
            ],
            [
                -5,
                3
            ],
            [
                -9,
                5
            ],
            [
                33,
                57
            ],
            [
                -134,
                80
            ],
            [
                -46,
                -50
            ],
            [
                -56,
                33
            ],
            [
                -13,
                8
            ]
        ],
        [
            [
                4322,
                3368
            ],
            [
                92,
                -38
            ],
            [
                24,
                -11
            ],
            [
                -9,
                -19
            ],
            [
                -32,
                -12
            ],
            [
                -112,
                -46
            ],
            [
                -68,
                -32
            ],
            [
                -59,
                -31
            ],
            [
                -33,
                -20
            ],
            [
                -9,
                -6
            ],
            [
                -12,
                -8
            ],
            [
                -13,
                -9
            ],
            [
                -34,
                -23
            ],
            [
                -118,
                -81
            ],
            [
                -28,
                -20
            ],
            [
                -31,
                -23
            ],
            [
                17,
                -36
            ],
            [
                1,
                -4
            ],
            [
                3,
                -7
            ],
            [
                3,
                -5
            ],
            [
                2,
                -5
            ],
            [
                2,
                -5
            ],
            [
                6,
                -13
            ],
            [
                25,
                -51
            ],
            [
                6,
                -12
            ],
            [
                32,
                -75
            ],
            [
                4,
                -13
            ],
            [
                62,
                -192
            ],
            [
                12,
                -38
            ],
            [
                1,
                -3
            ],
            [
                -53,
                -110
            ],
            [
                -14,
                -28
            ],
            [
                -6,
                -5
            ],
            [
                -48,
                -38
            ],
            [
                -119,
                -96
            ],
            [
                -47,
                -38
            ],
            [
                -1,
                -2
            ],
            [
                -42,
                -45
            ],
            [
                -49,
                -53
            ],
            [
                -25,
                23
            ],
            [
                -10,
                -10
            ],
            [
                -15,
                -8
            ],
            [
                -8,
                -4
            ],
            [
                -8,
                -3
            ],
            [
                -9,
                -2
            ],
            [
                -8,
                -1
            ],
            [
                -9,
                0
            ],
            [
                -9,
                0
            ],
            [
                -9,
                2
            ],
            [
                -9,
                2
            ],
            [
                -8,
                3
            ],
            [
                -8,
                4
            ],
            [
                -7,
                4
            ],
            [
                -7,
                6
            ],
            [
                -6,
                6
            ],
            [
                -6,
                6
            ],
            [
                -4,
                7
            ],
            [
                -4,
                7
            ],
            [
                -3,
                8
            ],
            [
                -2,
                8
            ],
            [
                -2,
                8
            ],
            [
                4,
                41
            ],
            [
                5,
                17
            ],
            [
                -2,
                -5
            ],
            [
                -3,
                -7
            ],
            [
                -4,
                -7
            ],
            [
                -5,
                -6
            ],
            [
                -5,
                -6
            ],
            [
                -6,
                -6
            ],
            [
                -7,
                -4
            ],
            [
                -99,
                -34
            ],
            [
                -16,
                -7
            ],
            [
                -16,
                -10
            ],
            [
                -49,
                -33
            ],
            [
                -11,
                -3
            ],
            [
                -86,
                -4
            ],
            [
                -48,
                -14
            ],
            [
                -21,
                -3
            ],
            [
                -24,
                0
            ],
            [
                -23,
                4
            ],
            [
                -14,
                5
            ],
            [
                -20,
                12
            ],
            [
                -47,
                37
            ],
            [
                -17,
                19
            ],
            [
                -36,
                42
            ],
            [
                -50,
                59
            ],
            [
                -6,
                6
            ],
            [
                -2,
                3
            ],
            [
                -5,
                -4
            ],
            [
                -77,
                -56
            ]
        ],
        [
            [
                2811,
                2217
            ],
            [
                -13,
                21
            ],
            [
                -8,
                15
            ],
            [
                -42,
                83
            ],
            [
                -2,
                3
            ],
            [
                -6,
                13
            ],
            [
                -14,
                13
            ],
            [
                -77,
                68
            ],
            [
                -17,
                15
            ],
            [
                -281,
                229
            ],
            [
                -29,
                25
            ],
            [
                -60,
                54
            ],
            [
                -27,
                25
            ],
            [
                -20,
                18
            ],
            [
                -42,
                40
            ],
            [
                -18,
                19
            ],
            [
                -30,
                25
            ],
            [
                -39,
                33
            ],
            [
                -13,
                3
            ],
            [
                -67,
                14
            ],
            [
                -82,
                15
            ],
            [
                -55,
                9
            ],
            [
                -35,
                5
            ],
            [
                -10,
                2
            ],
            [
                -3,
                1
            ],
            [
                -5,
                2
            ],
            [
                -50,
                15
            ],
            [
                -9,
                2
            ],
            [
                -70,
                14
            ],
            [
                -43,
                9
            ],
            [
                1,
                2
            ],
            [
                -4,
                10
            ],
            [
                0,
                18
            ],
            [
                2,
                6
            ],
            [
                4,
                8
            ],
            [
                33,
                38
            ],
            [
                2,
                3
            ],
            [
                31,
                38
            ],
            [
                16,
                19
            ],
            [
                39,
                45
            ],
            [
                16,
                19
            ],
            [
                -37,
                18
            ],
            [
                -29,
                22
            ],
            [
                -19,
                13
            ],
            [
                54,
                67
            ],
            [
                9,
                10
            ],
            [
                6,
                11
            ],
            [
                4,
                7
            ],
            [
                16,
                23
            ],
            [
                4,
                4
            ],
            [
                43,
                58
            ],
            [
                12,
                16
            ],
            [
                107,
                142
            ],
            [
                6,
                12
            ],
            [
                4,
                6
            ],
            [
                22,
                22
            ],
            [
                18,
                -14
            ],
            [
                9,
                -6
            ],
            [
                68,
                85
            ],
            [
                7,
                4
            ],
            [
                6,
                5
            ],
            [
                35,
                44
            ],
            [
                22,
                27
            ],
            [
                29,
                37
            ],
            [
                15,
                20
            ],
            [
                6,
                7
            ],
            [
                3,
                3
            ],
            [
                24,
                43
            ],
            [
                9,
                5
            ],
            [
                4,
                3
            ],
            [
                72,
                91
            ],
            [
                11,
                19
            ],
            [
                9,
                11
            ],
            [
                -3,
                1
            ],
            [
                16,
                25
            ],
            [
                -6,
                3
            ],
            [
                -12,
                7
            ],
            [
                33,
                55
            ],
            [
                9,
                -5
            ],
            [
                14,
                20
            ],
            [
                11,
                7
            ]
        ],
        [
            [
                9676,
                2090
            ],
            [
                -140,
                -195
            ],
            [
                -112,
                -160
            ],
            [
                -154,
                -222
            ],
            [
                -2,
                -3
            ],
            [
                -413,
                -607
            ],
            [
                -41,
                -59
            ],
            [
                -158,
                -232
            ],
            [
                -6,
                -9
            ],
            [
                -29,
                -43
            ],
            [
                -56,
                -82
            ],
            [
                -56,
                -82
            ],
            [
                -16,
                -23
            ],
            [
                -181,
                -270
            ],
            [
                -39,
                -56
            ],
            [
                -152,
                -47
            ],
            [
                0,
                11
            ],
            [
                -6,
                2
            ],
            [
                -17,
                -3
            ],
            [
                -366,
                274
            ],
            [
                -8,
                6
            ],
            [
                -46,
                34
            ],
            [
                -20,
                15
            ],
            [
                -18,
                13
            ],
            [
                -34,
                26
            ],
            [
                -105,
                78
            ],
            [
                -86,
                64
            ],
            [
                -200,
                149
            ],
            [
                -29,
                22
            ],
            [
                -194,
                144
            ],
            [
                -73,
                55
            ],
            [
                -70,
                52
            ],
            [
                -20,
                14
            ],
            [
                -79,
                60
            ],
            [
                -31,
                23
            ],
            [
                -26,
                19
            ],
            [
                -72,
                54
            ],
            [
                -60,
                45
            ],
            [
                -7,
                52
            ],
            [
                -9,
                73
            ],
            [
                -3,
                9
            ],
            [
                -1,
                3
            ],
            [
                -10,
                15
            ],
            [
                -1,
                2
            ],
            [
                -8,
                9
            ],
            [
                -13,
                6
            ],
            [
                -36,
                25
            ],
            [
                -7,
                4
            ],
            [
                -36,
                21
            ],
            [
                -9,
                1
            ],
            [
                -15,
                1
            ],
            [
                -30,
                3
            ],
            [
                -6,
                1
            ],
            [
                -62,
                17
            ],
            [
                -38,
                11
            ],
            [
                -16,
                7
            ],
            [
                -19,
                5
            ],
            [
                -17,
                3
            ],
            [
                -65,
                -9
            ],
            [
                -58,
                -8
            ],
            [
                -42,
                -9
            ],
            [
                -44,
                0
            ],
            [
                -8,
                -26
            ],
            [
                -64,
                -61
            ],
            [
                -44,
                -27
            ],
            [
                -648,
                -24
            ],
            [
                -43,
                -2
            ],
            [
                -98,
                0
            ],
            [
                -105,
                0
            ],
            [
                -47,
                -21
            ],
            [
                -12,
                -5
            ],
            [
                -90,
                -10
            ],
            [
                -230,
                -25
            ],
            [
                -4,
                0
            ],
            [
                -9,
                -1
            ],
            [
                -4,
                -1
            ],
            [
                -66,
                -7
            ],
            [
                -43,
                0
            ],
            [
                -22,
                0
            ],
            [
                -42,
                -7
            ],
            [
                -9,
                -2
            ],
            [
                -7,
                0
            ],
            [
                -110,
                -5
            ],
            [
                -8,
                -1
            ],
            [
                -48,
                -2
            ],
            [
                -22,
                0
            ],
            [
                -14,
                -4
            ],
            [
                -22,
                -5
            ],
            [
                -281,
                -16
            ],
            [
                -22,
                -2
            ],
            [
                -38,
                -4
            ],
            [
                -34,
                -4
            ],
            [
                -81,
                -7
            ],
            [
                -27,
                -2
            ],
            [
                -55,
                -8
            ],
            [
                -11,
                -2
            ],
            [
                -43,
                -6
            ],
            [
                -7,
                -1
            ],
            [
                -21,
                8
            ],
            [
                -127,
                87
            ],
            [
                -29,
                19
            ],
            [
                -34,
                25
            ],
            [
                -1,
                0
            ],
            [
                -60,
                43
            ],
            [
                -74,
                45
            ],
            [
                -80,
                40
            ],
            [
                -7,
                4
            ],
            [
                -54,
                33
            ],
            [
                -50,
                30
            ],
            [
                -54,
                33
            ],
            [
                -94,
                367
            ],
            [
                -22,
                79
            ],
            [
                -17,
                73
            ],
            [
                -48,
                207
            ],
            [
                -8,
                13
            ]
        ]
    ],
    "bbox": [
        -74.251361,
        40.673903,
        -74.112787,
        40.788244
    ],
    "transform": {
        "scale": [
            0.000013858785878588413,
            0.000011435243524352039
        ],
        "translate": [
            -74.251361,
            40.673903
        ]
    }
}